import React from 'react'
import { LinearProgress, Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material'
import { ObservatoryRow } from 'common/types'
import { StageAlertLevel } from 'common/consts'
import { DenseTableCell } from './DenseTableCell'
import { useGlobalState } from 'state'

type StageMonitorProps = {
  height: string | number
  stages: ObservatoryRow[]
}

type StageRow = ObservatoryRow & {
  graph: number;
};

export const StageMonitor = ({stages, height}: StageMonitorProps) => {
  const state = useGlobalState()
  const [rows, setRows] = React.useState<StageRow[]>([])

  React.useEffect(() => {
    const targets = stages.map(s => {
      let graph = 0
      if (s.level !== undefined) {
        if (s.outbreakLevel !== undefined) {
          graph = Math.floor(s.level / s.outbreakLevel * 100)
        } else if (s.dangerousLevel !== undefined) {
          graph = Math.floor(s.level / s.dangerousLevel * 100)
        }
        if (graph < 0) {
          graph = 1
        } else if (graph > 100) {
          graph = 100
        }
      }
      return {...s, graph: graph}
    })
    setRows(targets)
  }, [stages])

  const handleClick = (row: StageRow) => {
    state.observatory.setSelected(row)
    state.app.setObservatoryContainer(true)
    state.map.setView(row.lng, row.lat, 12)
  }

  return (
    <TableContainer sx={{height: height}}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <DenseTableCell th text="観測所名" left />
            <DenseTableCell th text={'氾濫\n注意'} color={StageAlertLevel.WARNING.color} />
            <DenseTableCell th text={'避難\n判断'} color={StageAlertLevel.EVACUATION.color} />
            <DenseTableCell th text={'氾濫\n危険'} color={StageAlertLevel.DANGEROUS.color} />
            <DenseTableCell th text={'氾濫\n発生'} color={StageAlertLevel.OUTBREAK.color} />
            <DenseTableCell th text={'現在\n水位'} />
            <DenseTableCell th text={'グラフ'} />
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => (
            <TableRow key={i} sx={{ cursor: 'pointer' }} hover onClick={() => handleClick(row)}>
              <DenseTableCell text={row.name} left />
              <DenseTableCell text={row.warningLevel === undefined ? '-' : row.warningLevel.toFixed(2)} />
              <DenseTableCell text={row.evacuationLevel === undefined ? '-' : row.evacuationLevel.toFixed(2)} />
              <DenseTableCell text={row.dangerousLevel === undefined ? '-' : row.dangerousLevel.toFixed(2)} />
              <DenseTableCell text={row.outbreakLevel === undefined ? '-' : row.outbreakLevel.toFixed(2)} />
              <DenseTableCell text={row.level === undefined ? '-' : row.level.toFixed(2)} />
              <DenseTableCell>
                <LinearProgress variant="determinate" sx={{height: 16}} value={row.graph} />
              </DenseTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
